module.exports = __webpack_public_path__ + "static/media/org.1881e761.svg";